<template>
	<div style="background:var(--grey-3);width:100%;justify-content: center;height:140px;" class="flexcenter">
		<img style="" :src="src" :title="title"/>
	</div>
</template>
<script>

// https://public.boove.se/w2image/img130515_dl_832894829b30fdb995039a17bd7b74d2_img_130515_imp_917427c688.jpg

//import SelectManufactor from '@/components/product/search/SelectManufactor.vue';
//import { STORE_GETTER } from '@/store/store';

//import LazyLoadDirective from "@/directives/LazyLoadDirective";
import settings from "@/settings";

export default {
	name: "ProductSearchImage",
	components: {},
	mixins: [],
	props: {
		fileName: String,
		parentTitle: String,
	},
	directives: {
		//lazyload: LazyLoadDirective
	},
	data() {
		return {

		};
	},
	computed: {

		title(){
			if (this.debug){
				return this.parentTitle + "\nProductSearchImage:\n" + this.fileName;
			}else{
				return this.parentTitle;
			}
			
		},

		src() {

			if (this.fileName == null || this.fileName == "") {
				return require("@/assets/missing.jpg");
			}

			return settings.baseImagePath + this.fileName;
		}

	},

};
</script>

<style scoped>

div img {
	width: calc(100% - 10px);
	height: calc(100% - 10px);
	margin: 0 auto;
	object-fit: contain;
	padding: 5px;

}
</style>